import React, { createContext, useContext, useMemo } from 'react';
import { resolveTenant } from '../config/tenants';

const TenantContext = createContext(null);

export function TenantProvider({ children }) {
  const tenant = useMemo(() => resolveTenant(), []);

  const value = useMemo(
    () => ({
      tenant,
      isMeliTenant: tenant === 'meli',
    }),
    [tenant]
  );

  return <TenantContext.Provider value={value}>{children}</TenantContext.Provider>;
}

export function useTenant() {
  const ctx = useContext(TenantContext);
  if (!ctx) {
    throw new Error('useTenant must be used within TenantProvider');
  }
  return ctx;
}
